import React, { useState } from "react"
import { ErrorBoundary } from "../ErrorBoundary"
import { TeamTable } from "./TeamTable"
import { InviteMemberForm } from "./InviteMemberForm"

// Settings → Team page. Standalone mount; nests under Settings in the sidebar.
export default function SettingsTeamApp({ membershipsPath, partnerId, team, copy, canManageOwner, currentUserId }) {
  const [teamState, setTeamState] = useState(team)

  // Prepend a freshly-invited member, replacing any existing row for the same
  // membership id (defensive against re-invites).
  const handleInvited = (member) =>
    setTeamState((prev) => [member, ...prev.filter((m) => m.id !== member.id)])

  return (
    <ErrorBoundary>
      <div className="space-y-6">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">{copy.title}</h1>
        <div className="space-y-4">
          <InviteMemberForm
            membershipsPath={membershipsPath}
            onInvited={handleInvited}
            roles={copy.roles}
            copy={copy}
          />
          <TeamTable
            team={teamState}
            setTeam={setTeamState}
            membershipsPath={membershipsPath}
            currentPartnerId={partnerId}
            canManageOwner={canManageOwner}
            currentUserId={currentUserId}
            copy={copy}
          />
        </div>
      </div>
    </ErrorBoundary>
  )
}
